// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___Iauy6","links":"links___pkH3B","submit":"submit___w2u8g"};